<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            @let kpi = kpis()[0];
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.producersNumberTotal.title"
                        [body]="{
                            value: kpi.producersNumberTotal,
                            precision: texts.producersNumberTotal.precision,
                        }"
                        [badge]="{
                            value: kpi.producersNumberTotalEvolution,
                            suffix: texts.producersNumberTotal.badgeSuffix,
                            precision: texts.producersNumberTotal.badgePrecision,
                            style: kpi.producersNumberTotalEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.producersNumberTotal.descriptionTitle"
                        [descriptionContent]="texts.producersNumberTotal.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'producersNumberTotal')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.powerTotal.title"
                        [body]="{
                            value: kpi.powerTotal,
                            precision: texts.powerTotal.precision,
                        }"
                        [badge]="{
                            value: kpi.powerTotalEvolution,
                            suffix: texts.powerTotal.badgeSuffix,
                            precision: texts.powerTotal.badgePrecision,
                            style: kpi.powerTotalEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'powerTotal')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
            </div>

            <chart-card
                id="facilitiesDistributionChart"
                [title]="texts.facilitiesDistributionChart.title"
                [error]="facilitiesDistributionChartError"
                [isLoading]="!facilitiesDistributionChartData()[0].organizationId"
                [series]="facilitiesDistributionChartSeries"
                [dataLabels]="facilitiesDistributionDataLabels"
                [stacked]="true"
                [yaxis]="facilitiesDistributionYaxis"
                [xaxisTitle]="texts.facilitiesDistributionChart.xaxisTitle"
                class="h-100">
            </chart-card>

            <div class="row g-3">
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="facilitiesEvolutionChart"
                        [title]="texts.facilitiesEvolutionChart.title"
                        [error]="facilitiesEvolutionChartError"
                        [isLoading]="!facilitiesEvolutionChartData()[0].organizationId"
                        [series]="facilitiesEvolutionChartSeries"
                        [dataLabels]="facilitiesEvolutionDataLabels"
                        [stacked]="true"
                        [yaxis]="facilitiesEvolutionYaxis"
                        [xaxisCategories]="facilitiesEvolutionXaxisCategories"
                        [customTooltip]="facilitiesEvolutionCustomTooltip"
                        [xaxisTitle]="texts.facilitiesEvolutionChart.xaxisTitle"
                        class="h-100">
                    </chart-card>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="facilitiesPowerEvolutionChart"
                        [title]="texts.facilitiesPowerEvolutionChart.title"
                        [error]="facilitiesPowerEvolutionChartError"
                        [isLoading]="!facilitiesPowerEvolutionChartData()[0].organizationId"
                        [series]="facilitiesPowerEvolutionChartSeries"
                        [dataLabels]="facilitiesPowerEvolutionDataLabels"
                        [stacked]="true"
                        [yaxis]="facilitiesPowerEvolutionYaxis"
                        [precision]="null"
                        [xaxisTitle]="texts.facilitiesPowerEvolutionChart.xaxisTitle"
                        [legend]="facilitiesPowerLegend"
                        [customTooltip]="facilitiesPowerCustomTooltip"
                        class="h-100">
                    </chart-card>
                </div>
            </div>
        </div>
    </div>
</div>
